<script lang="ts">
  /**
   * Imports
   * ---------------------------------------------------------------------------
   */

  import { convertStatamicAssetToCDN } from "@utils/cdn";
  import type { StatamicAsset } from "@customTypes/statamic";
  import clsx from "clsx";

  /**
   * Props
   * ---------------------------------------------------------------------------
   */

  /** name text */
  export let name: string;

  /** prose HTML */
  export let prose: string;

  /** image data */
  export let image: StatamicAsset;
</script>

<!-- Template ----------------------------------------------------------------->

<div
  class={clsx(
    "grid gap-y-0 gap-x-8 pt-12", // general
    "grid-cols-1", // small
    "md:grid-cols-[auto_auto] md:grid-rows-[auto_auto]", // medium+
  )}
>
  <div
    class={clsx(
      "col-start-1 not-prose flex justify-center", // general
      "mb-4", // small
      "md:mb-0 md:row-span-2", // medium+
    )}
  >
    <img
      src={convertStatamicAssetToCDN(image.id) || ""}
      alt={name}
      class="w-3/4 md:w-48 md:h-48 lg:w-64 lg:h-64"
    />
  </div>
  <div class="col-start-1 md:col-start-2"><h2 class="p-0 m-0">{name}</h2></div>
  <div class="col-start-1 md:col-start-2">{@html prose}</div>
</div>
